import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { login, googleSignup, googleLogin, logout, clearErrorsAction } from '../../actions/session_actions';

import { forgotPassword } from '../../actions/user_actions';

import SocialRegisterPage from './social_register_page';

const mapStateToProps = (state, ownProps) => {

  const loggedIn = Boolean(state.session.currentUser)
  let currentUser = loggedIn ? state.session.currentUser : null;
  let errors = state.errors.session;

  return {
    currentUser,
    loggedIn,
    errors
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  signup: user => dispatch(googleSignup(user)),
  login: user => dispatch(login(user)),
  googleLogin: token => dispatch(googleLogin(token)),
  clearErrors: user => dispatch(clearErrorsAction()),
  forgotPassword: data => dispatch(forgotPassword(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SocialRegisterPage));
